
export function getApiUrl() {

    if (document.location.hostname == 'ui.dev.lauer-it.cloud') {
        return 'https://api.dev.lauer-it.cloud/'
    } else if (document.location.hostname == 'ui.lauer-it.cloud') {
        return 'https://api.lauer-it.cloud/'
    }

    return 'http://localhost:8030'
    //return 'https://api.dev.lauer-it.cloud/'
}